import { createRouter } from '@tanstack/react-router'

import { routeTree } from './routeTree.gen'

export const router = createRouter({
  routeTree,
  scrollRestoration: true,
  // Replaced by `AppRouter`, which reads the role from the signed-in session.
  // No route is entered before that happens: the guard renders the router only
  // once a role exists.
  context: { role: undefined! },
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
